import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto max-w-3xl p-2 text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Images from the on-chain asset provider.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProviderView = _resolveComponent("ProviderView")!
  const _component_Mint = _resolveComponent("Mint")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ProviderView, { assetProvider: "reddit" }),
    _createVNode(_component_Mint, {
      network: _ctx.network,
      tokenGated: true,
      tokenAddress: _ctx.tokenAddress,
      tokenGateAddress: _ctx.tokenGateAddress,
      restricted: 'On-Chain Splatter'
    }, null, 8, ["network", "tokenAddress", "tokenGateAddress"])
  ]))
}